import { Kommuter } from "./Kommuter";

export const kommuter = new Kommuter();
export const $kommuter = kommuter;

// @ts-ignore
window.$kommuter = kommuter;
